<template>
  <div class="container mt-5" style="height: 100vh; overflow-y: auto;">
    <div class="d-flex flex-column justify-content-start align-items-center h-100 container-top">
      <b-img v-for="id in imageCount" :key="id" v-bind="mainProps" :src="getImageUrl(id)" :alt="`Page${id}`" class="img-fluid"></b-img>
    </div>
  </div>
</template>

<script setup>

import { useRoute } from 'vue-router';

const mainProps = {
  center: true,
  fluidGrow: true,
  width: 600,
  height: 400,
  class: 'mt-5'
};

const route = useRoute();
const equipment = route.query.equipment || 'N20';
let imageCount = 0;
switch (equipment) {
  case 'D20':
    imageCount = 10;
    break;
  case 'N20':
    imageCount = 12;
    break;
  case 'D21':
    imageCount = 10;
    break;
  case 'N12':
    imageCount = 12;
    break;
  case 'N80':
    imageCount = 26;
    break;
  case 'D80':
    imageCount = 24;
    break;
  default:
    imageCount = 0;
    break;
}

const getImageUrl = (id) => {
  const lang = route.query.lang || 'en';
  const equipment = route.query.equipment || 'N20';
  return `https://d3j9vygjocoacx.cloudfront.net/guide/${equipment}-images/${lang}/${id}-zip.jpg`;
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh; /* 设置容器高度为视口高度 */
  overflow-y: auto; /* 添加垂直滚动条 */
}

.img-fluid {
  max-width: 100%;
  height: auto;
  margin-bottom: -36px; /* 添加一些间距 */
}
.container-top{
  margin-top: 0;
}
</style>
